import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const ResetPasswordPage = () => {
    const [newPassword, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [ready, setReady] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        supabase.auth.getSession().then(({ data: {session}, error }) => {
            if (!session) {
                setError({message: 'Incorrect or expired link', type: 'is-danger'});
                return;
            }
            setReady(true);
        })
    }, [])


    const handleResetPassword = async (e) => {
        e.preventDefault();
        if (ready) {
            setLoading(true);
            setError(null);

            const { data, error } = await supabase.auth.updateUser({
                password: newPassword
            })
            if (error) {
                setError({ message: error.message, type: 'is-danger' });
                setLoading(false);
            } else {
                setError({ message: "Password changed successfully!", type: 'is-primary' });
                setTimeout(() => {
                    setLoading(false);
                    navigate('/dashboard');
                }, 2000);
            }
        }
    };

    return (
        <section className="section is-fullheight has-background-light">
            <div className="container">
                <div className="box p-5" style={{ width: '400px', margin: 'auto' }}>
                    <h1 className="title has-text-centered mb-5">Change Password</h1>
                    {error && (
                        <div className={`notification ${error.type}`}>
                            <button className="delete" onClick={() => setError(null)}></button>
                            {error.message}
                        </div>
                    )}
                    <p>Do <b>NOT</b> refresh this page!</p>
                    <form onSubmit={handleResetPassword}>
                        <div className="field mb-4">
                            <label className="label" htmlFor="password-login">Password</label>
                            <div className="control has-icons-left">
                                <input
                                    className="input"
                                    type="password"
                                    id="password-login"
                                    placeholder="********"
                                    value={newPassword}
                                    onChange={(e) => setPassword(e.target.value)}
                                    disabled={loading}
                                    required
                                />
                                <span className="icon is-small is-left">
                                    <i className="fas fa-lock"></i>
                                </span>
                            </div>
                        </div>

                        <div className="field mt-5">
                            <button
                                className={`button is-link is-fullwidth ${loading ? 'is-loading' : ''}`}
                                type="submit"
                                disabled={loading || ready}
                            >
                                <span className="icon is-small is-left">
                                    <i className="fas fa-lock"></i>
                                </span>
                                <span>Change password</span>
                            </button>
                        </div>
                    </form>

                    <p className="has-text-left mt-5">
                        <Link to="/">Return home</Link>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default ResetPasswordPage;